<template>
  <div class="recharge-container">
    <!-- 顶部横幅 -->
    <div class="banner-card">
      <h2 class="banner-title">卡密提取SUNO账号</h2>
      <p class="banner-sub">安全、快捷的卡密服务</p>
    </div>

    <div class="recharge-box">
      <!-- 两步进度条 -->
      <el-steps :active="step" finish-status="success" align-center>
        <el-step title="验证卡密"/>
        <el-step title="获取SUNO成品账号"/>
      </el-steps>

      <!-- 步骤一：验证卡密 -->
      <div v-show="step === 1" class="step-pane">
        <el-form :model="form" ref="formRef">
          <el-form-item prop="card">
            <el-input
                v-model="form.card"
                placeholder="请输入卡密（如没有，请先联系客服获得）"
                prefix-icon="el-icon-key"
                maxlength="120"
                @keyup.enter.native="handleVerify"
            />
          </el-form-item>

          <el-form-item>
            <el-button
                type="primary"
                class="action-btn"
                :loading="loading"
                :disabled="verifyDisabled"
                @click="handleVerify"
            >
              验证卡密
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 步骤二：兑换账号 -->
      <div v-show="step === 2" class="step-pane">
        <template v-if="!accountFetched">
          <el-alert
              type="info"
              show-icon
              title="请点击下方按钮以获取对应账号"
              :closable="false"
              class="mb12"
          />
          <el-button type="primary" :loading="fetching" @click="fetchAccount">
            {{ fetching ? '获取中...' : '获取SUNO账号信息' }}
          </el-button>
        </template>

        <template v-else>
          <el-card shadow="never" class="result-card">
            <div class="result-head">
              <span class="result-title">账号内容</span>
              <div class="result-actions">
                <el-button size="mini" @click="copy(accountInfo)">复制账号</el-button>
                <el-button size="mini" type="primary" @click="openWebsite">进入官网</el-button>
              </div>
            </div>
            <pre class="mono-txt">{{ accountInfo }}</pre>
          </el-card>
          <p class="hint">请妥善保管账号信息，离开页面后无法再次查看！！！</p>
        </template>


      </div>
    </div>
  </div>
</template>

<script>
import {rechargeApi, siteApi} from '@/utils/api'
import {closeBrowser, generateUUID, launchBrowser} from "@/utils/native";

export default {
  name: 'RechargePage',
  data() {
    return {
      websiteId: 10002,
      step: 1,
      loading: false,   // 验证阶段 loading
      fetching: false,  // 兑换账号阶段 loading
      form: {card: ''},
      accountInfo: '',      // 第二步返回的 data，按纯文本处理
      accountFetched: false,
      targetUrl: "https://suno.com/create",
      ENV: "prod", // 默认 prod，created 里按路由参数覆盖
    }
  },
  created() {
    this.token = this.$route.query.token;

    // 从 URL 参数获取 env（dev 表示开发环境）
    const {env} = this.$route.query || {};
    if (typeof env === "string") this.ENV = env;

    this.browserId = localStorage.getItem("browserId") || generateUUID();
    localStorage.setItem("browserId", this.browserId);
  },
  computed: {
    verifyDisabled() {
      return !this.form.card || this.loading
    }
  },
  methods: {
    //充值内容
    async reset(){
      this.form.card = '';
      this.step = 1;
      this.accountInfo = '';
    },

    // 1) 验证卡密
    async handleVerify() {
      if (!this.form.card) {
        this.$message.error('请输入卡密')
        return
      }
      this.loading = true
      try {
        const res = await rechargeApi.checkCard({
          code: this.form.card,
          token: this.token
        })
        if (res?.code === 0) {
          this.step = 2
          this.accountFetched = false
          this.$message.success(res.msg || '验证成功')
        } else {
          this.$message.error(res?.msg || '验证失败')
        }
      } catch (e) {
        this.$message.error('验证失败：' + (e?.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },

    // 2) 激活卡密并获取账号内容
    async fetchAccount() {
      if (this.fetching) return
      this.fetching = true
      try {
        const res = await rechargeApi.activeCard({
          code: this.form.card,
          token: this.token
        })
        if (res?.code === 0) {
          // data 是“卡密具体内容”，直接展示与复制
          this.accountInfo = res.data.accountInfo;
          this.targetUrl = res.data.targetUrl;
          this.accountFetched = true
          this.$message.success(res.msg || '获取成功')
        } else {
          this.$message.error(res?.msg || '获取失败')
        }
      } catch (e) {
        this.$message.error('兑换账号失败：' + (e?.message || '未知错误'))
      } finally {
        this.fetching = false
      }
    },

    // 复制文本
    async copy(text) {
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('已复制到剪贴板')
      } catch {
        const input = document.createElement('input')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('已复制到剪贴板')
      }
    },

    async openWebsite() {
      // if (this.targetUrl) {
      //   window.open(this.targetUrl, '_blank');
      // } else {
      //   this.$message.warning('暂无可访问的网址');
      // }

      try {
        // 1) 权限检查
        const accessResponse = await siteApi.checkBrowserAccess({
          websiteId: this.websiteId,
        });
        if (accessResponse?.code !== 0) {
          this.$message.error(accessResponse?.msg || "访问权限不足，请联系客服");
          return;
        }

        // 2) 准备参数
        const token = localStorage.getItem("authToken") || "";
        const userId = localStorage.getItem("userId") || "";
        if (!token || !userId) {
          this.$message.error("登录信息缺失，请先登录");
          return;
        }
        // 3) 打开方式：dev -> window.open；prod -> 调用本地
        if (this.ENV === "dev") {
          window.open(this.targetUrl, "_blank");
          return;
        } else {
          try {
            await closeBrowser(this.browserId);
          } catch (error) {
            console.error("close失败:", error);
          }

          const launchItem = {
            browserId: this.browserId,
            websiteId: this.websiteId,
            targetUrl: this.targetUrl,
            userId: userId,
            token: token,
          };
          await launchBrowser(launchItem);
        }
        // 4) 上报 open
        await siteApi.uploadAction({
          action: "open",
          websiteId: this.websiteId,
          browserId: this.browserId,
        });
        this.$message.success("打开成功");
      } catch (error) {
        console.error("error:", error);
        this.$message.error("访问权限不足，请联系客服。");
      }
    }
  }
}
</script>

<style scoped>
.recharge-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 12px 48px;
  background: #f5f5f8;
}

.banner-card {
  width: 100%;
  max-width: 980px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .06);
  padding: 28px 16px;
  text-align: center;
}

.banner-title {
  margin: 0;
  font-size: 28px;
  color: #475569;
}

.banner-sub {
  margin: 6px 0 0;
  color: #8b94a7;
}

.recharge-box {
  width: 100%;
  max-width: 980px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .06);
  padding: 18px 16px 22px;
}

.step-pane {
  padding: 18px 6px 6px;
}

.action-btn {
  width: 100%;
}

.mb12 {
  margin-bottom: 12px;
}

.result-card {
  margin-top: 12px;
}

.result-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.result-title {
  font-weight: 600;
  color: #374151;
}

.result-actions > .el-button + .el-button {
  margin-left: 8px;
}

.mono-txt {
  white-space: pre-wrap;
  word-break: break-word;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  letter-spacing: .2px;
}

.hint {
  color: red;
  margin: 8px 2px 0;
}

.actions {
  margin-top: 10px;
}

/* 自适应 */
@media (max-width: 720px) {
  .recharge-container {
    padding: 16px 10px 28px;
  }

  .banner-title {
    font-size: 22px;
  }
}
</style>
